import type { Step } from "react-joyride";

export const templateFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມສ້າງ/ແກ້ໄຂຮ່າງເອກະສານ! ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຟອມນີ້ໃນບົດສອນສັ້ນໆນີ້. ຮ່າງເອກະສານຈະຊ່ວຍທ່ານກຳນົດແບບຟອມມາດຕະຖານສຳລັບການດຳເນີນງານ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="form-name"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຊື່ຮ່າງເອກະສານ. ກະລຸນາໃສ່ຊື່ທີ່ຊັດເຈນແລະອະທິບາຍວ່າຮ່າງເອກະສານນີ້ສຳລັບຫຍັງ. ຕົວຢ່າງ: 'ຮ່າງເອກະສານ PO (ສັ່ງຊື້)', 'ຮ່າງເອກະສານ PR (ການຊື້)'. ຊ່ອງນີ້ຈຳເປັນຕ້ອງປ້ອນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-description"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຄຳອະທິບາຍ. ທ່ານສາມາດໃສ່ຄຳອະທິບາຍເພີ່ມເຕີມກ່ຽວກັບຮ່າງເອກະສານນີ້ (ບໍ່ບັງຄັບ). ຄຳອະທິບາຍຈະຊ່ວຍໃຫ້ຜູ້ໃຊ້ອື່ນເຂົ້າໃຈຈຸດປະສົງຂອງຮ່າງເອກະສານນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-category"]',
    content:
      "ນີ້ແມ່ນການເລືອກປະເພດຮ່າງເອກະສານ. ທ່ານສາມາດເລືອກປະເພດທີ່ຮ່າງເອກະສານນີ້ຈະຖືກຈັດກຸ່ມ (ບໍ່ບັງຄັບ). ທ່ານຍັງສາມາດກົດປຸ່ມຈັດການປະເພດເພື່ອສ້າງປະເພດໃໝ່ໄດ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-departments"]',
    content:
      "ນີ້ແມ່ນການເລືອກພະແນກ. ທ່ານສາມາດເລືອກພະແນກທີ່ຮ່າງເອກະສານນີ້ຈະນຳໃຊ້ (ບໍ່ບັງຄັບ). ຖ້າບໍ່ເລືອກ, ຮ່າງເອກະສານນີ້ຈະສາມາດນຳໃຊ້ໄດ້ກັບທຸກພະແນກ. ທ່ານສາມາດເລືອກຫຼາຍພະແນກໄດ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-file"]',
    content:
      "ນີ້ແມ່ນພາກເລືອກຟາຍຮ່າງເອກະສານ. ທ່ານຕ້ອງເລືອກຟາຍຮ່າງເອກະສານຈາກຄັງສື່ (PDF / Word / Excel). ຖ້າທ່ານກຳລັງແກ້ໄຂ, ການເລືອກຟາຍໃໝ່ຈະສ້າງເວີຊັນໃໝ່ອັດຕະໂນມັດ. ຊ່ອງນີ້ຈຳເປັນຕ້ອງເລືອກເມື່ອສ້າງໃໝ່.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-version"]',
    content:
      "ນີ້ແມ່ນຊ່ອງລະບຸເວີຊັນ. ທ່ານສາມາດໃສ່ເລກເວີຊັນດ້ວຍຕົນເອງ (ບໍ່ບັງຄັບ). ຖ້າບໍ່ໃສ່, ລະບົບຈະສ້າງເລກເວີຊັນອັດຕະໂນມັດ. ຕົວຢ່າງ: '1.0', '2.0', '1.1'. ພາກນີ້ຈະສະແດງເມື່ອທ່ານເລືອກຟາຍ ຫຼື ກຳລັງແກ້ໄຂ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-changelog"]',
    content:
      "ນີ້ແມ່ນຊ່ອງໝາຍເຫດການປ່ຽນແປງ (Changelog). ທ່ານສາມາດໃສ່ລາຍລະອຽດການປ່ຽນແປງຂອງເວີຊັນນີ້ (ບໍ່ບັງຄັບ). ຕົວຢ່າງ: 'ເພີ່ມຟິວໃໝ່', 'ແກ້ໄຂຮ່າງແບບ', 'ປັບປຸງການຄິດໄລ່'. ຂໍ້ມູນນີ້ຈະຊ່ວຍໃຫ້ຜູ້ໃຊ້ອື່ນເຂົ້າໃຈການປ່ຽນແປງ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-keep-old-versions"]',
    content:
      "ນີ້ແມ່ນ checkbox ຮັກສາເວີຊັນເກົ່າໃຫ້ເປັນການໃຊ້ງານ. ຖ້າກົດ checkbox ນີ້, ເວີຊັນເກົ່າຈະຍັງສາມາດໃຊ້ງານໄດ້ເມື່ອມີເວີຊັນໃໝ່. ຖ້າບໍ່ກົດ, ເວີຊັນເກົ່າຈະຖືກປິດການໃຊ້ງານອັດຕະໂນມັດ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-submit"]',
    content:
      "ຫຼັງຈາກຕື່ມຂໍ້ມູນຄົບຖ້ວນແລ້ວ, ກົດປຸ່ມ 'ສ້າງຮ່າງເອກະສານ' (ສຳລັບການສ້າງໃໝ່) ຫຼື 'ບັນທຶກການແກ້ໄຂ' (ສຳລັບການແກ້ໄຂ) ເພື່ອບັນທຶກຮ່າງເອກະສານຂອງທ່ານ. ຮ່າງເອກະສານທີ່ບັນທຶກແລ້ວຈະສາມາດໃຊ້ງານໄດ້ທັນທີ.",
    placement: "top",
  },
];
